import { mergeClasses } from 'minimal-shared/utils';
import PropTypes from "prop-types";

import { styled } from '@mui/material/styles';


// ----------------------------------------------------------------------

export function FlagIcon({ code, className, sx, ...other }) {
  if (!code) {
    return null;
  }

  return (
    <FlagRoot className={mergeClasses([ className])} sx={sx} {...other}>
      <FlagImg
        loading="lazy"
        alt={code}
        src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${code?.toUpperCase()}.svg`}
      />
    </FlagRoot>
  );
}

// ----------------------------------------------------------------------

const FlagRoot = styled('span')(({ theme }) => ({
  width: 26,
  height: 20,
  flexShrink: 0,
  overflow: 'hidden',
  borderRadius: '5px',
  alignItems: 'center',
  display: 'inline-flex',
  justifyContent: 'center',
  backgroundColor: theme.palette.mode,
}));

const FlagImg = styled('img')(() => ({
  width: '100%',
  height: '100%',
  maxWidth: 'unset',
  objectFit: 'cover',
}));



FlagIcon.propTypes = {
  className: PropTypes.any,
  code: PropTypes.any,
  sx: PropTypes.object,
};
